import { motion } from "framer-motion";
import { Check, X, Minus } from "lucide-react";
import { COMPARISON } from "@/data/geo";

const cellIcon = (v) => {
  if (v === "Yes") return <Check className="inline h-4 w-4 text-[#25D366]" strokeWidth={3} />;
  if (v === "No") return <X className="inline h-4 w-4 text-[#D92D20]" strokeWidth={3} />;
  if (v === "Rarely" || v === "Manual" || v === "Portal only") return <Minus className="inline h-4 w-4 text-[#FDB022]" strokeWidth={3} />;
  return null;
};

export default function Comparison() {
  return (
    <section
      id="comparison"
      data-testid="comparison-section"
      className="border-b border-[#E4E7EC] bg-[#F9FAFB]"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="max-w-3xl">
          <p className="overline mb-4">§ 06a — Compare</p>
          <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-[#101828] sm:text-5xl md:text-6xl">
            Compared, honestly.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-[#475467]">
            The trade-offs global freight forwarders actually weigh when
            choosing an India desk. Ten criteria, three options.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.5 }}
          className="mt-12 overflow-x-auto border-2 border-[#101828] bg-white"
        >
          <table className="min-w-full text-sm" data-testid="comparison-table">
            <thead>
              <tr className="border-b-2 border-[#101828] bg-[#101828] text-white">
                <th className="px-5 py-4 text-left font-mono-accent text-[#FDB022]" scope="col">
                  CRITERION
                </th>
                {COMPARISON.columns.map((c, i) => (
                  <th
                    key={c}
                    scope="col"
                    className={`px-5 py-4 text-left font-display text-sm font-bold tracking-tight ${
                      i === 0 ? "bg-[#D92D20] text-white" : ""
                    }`}
                  >
                    {c}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {COMPARISON.rows.map((r, ri) => (
                <tr
                  key={r.criterion}
                  className={`border-b border-[#E4E7EC] last:border-b-0 ${
                    ri % 2 === 1 ? "bg-[#F9FAFB]" : ""
                  }`}
                >
                  <th scope="row" className="px-5 py-4 text-left font-semibold text-[#101828]">
                    {r.criterion}
                  </th>
                  {r.values.map((v, vi) => (
                    <td
                      key={vi}
                      className={`px-5 py-4 align-top text-[#475467] ${
                        vi === 0 ? "bg-[#FEF3F2] font-semibold text-[#101828]" : ""
                      }`}
                    >
                      <span className="mr-2">{cellIcon(v)}</span>
                      {v}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>
  );
}
